import React from 'react';
import { Modal } from 'react-responsive-modal';
import 'react-responsive-modal/styles.css';
import { useAirtableFetch } from '../hooks/useAirtableFetch';
import { Loader } from '../Loader';

interface FieldProps {
  product_name: string;
  product_cost: string[];
  product_description: string;
  product_number: number;
  product_image: any[];
  product_toppings: string[];
  product_type: string
}

export const MenuItems = (): React.ReactElement => {
  const [open, setOpen] = React.useState(false);
  const [selectedMenuItem, setSelectedMenuItem] = React.useState<FieldProps>();

  const onModalOpen = (menuItem: FieldProps):void => {
    setSelectedMenuItem(menuItem);
    setOpen(true);
  }

  const onModalClose = (): void => setOpen(false);

  const [menuItems, isLoading] = useAirtableFetch();
  const renderSize = (price: string, type: string) => {
    if (type === 'Vermicelli Bowl' || type === 'Shrimp and Vegetable Soup') return null;
    switch (price) {
      case '$12.95':
        return 'SM';
      case '$13.95':
        return 'SM';
      case '$14.95':
        return 'LG';
      case '$16.95':
        return 'XL';
      case '$15.95':
        return 'LG';
      default:
        return '';
    }
  }

  if (isLoading) return <Loader />

  return (
    <div className='container mx-auto w-full md:w-2/3 mb-16'>
      <div
        className='
          m-4 p-4
          bg-yellow-400 border-yellow-500 border-4 rounded-xl
          text-yellow-700
        '
        role='alert'
      >
        <p className='font-bold'>Pho Combo (Available after 3pm)</p>
        <div className='flex gap-4 items-center justify-between'>
          <ul>
            <li className='list-disc list-inside text-sm'>Large Pho of your choice</li>
            <li className='list-disc list-inside text-sm'>Assorted Spring Rolls + Grilled Pork Balls (appetizer)</li>
            <li className='list-disc list-inside text-sm'>1x Pop OR Vietnamese Coffee</li>
          </ul>
          <div className='flex flex-col items-center p-4 border-4 border-yellow-500 rounded-xl'>
            <p className='text-lg md:text-sm'>
              LG
            </p>
            <p>$20+GST</p>
          </div>
        </div>
      </div>
      <div className=''>
        {menuItems.map(({ fields }: { fields: FieldProps }) => {
          const imageSrc = fields?.product_image?.[0]?.thumbnails?.large?.url;
          if (fields.product_number === 31) return null;
          return (
            <div
              key={fields.product_number}
              className='
                flex flex-col md:flex-row gap-4 md:gap-0
                items-end md:items-center
                md:justify-between
                p-4 border-b-2'
            >
              <div className='flex w-full gap-2'>
                <p className='text-4xl md:text-base'>#{fields.product_number}</p>
                <div className='flex flex-col'>
                  {fields.product_name && (
                    <div className='flex items-center gap-4 mb-1'>
                      <p className='font-black'>{fields.product_name}</p>
                      {/* @ts-ignore */}
                      {imageSrc && (
                        <p
                          className='underline text-yellow-500 hover:text-blue-500 cursor-pointer'
                          onClick={() => onModalOpen(fields)}
                        >
                          View Photo
                        </p>
                      )}
                    </div>
                  )}
                  {/* @ts-ignore */}
                  {!fields.product_name && imageSrc && (
                    <p
                      className='underline text-yellow-500 hover:text-blue-500 cursor-pointer'
                      onClick={() => onModalOpen(fields)}
                    >
                      View Photo
                    </p>
                  )}
                  <div className='flex flex-wrap'>
                    {fields.product_toppings?.map((toppings, index) => {
                      if (index + 1 < fields.product_toppings.length) {
                        return (
                          <span className='text-2xl md:text-base tracking-wide'>{toppings},&nbsp;</span>
                        );
                      } else {
                        return (
                          <span className='text-2xl md:text-base tracking-wide'>{toppings}</span>
                          );
                        }
                      })}
                  </div>
                  <p className='text-sm italic'>{fields.product_type}</p>
                  <p className='text-lg md:text-sm text-gray-400'>{fields.product_description}</p>
                </div>
              </div>

              <div className='flex items-center gap-2'>
                {fields.product_cost?.map((cost, index) => {
                  return (
                    <div className='flex flex-col items-center p-4 border-2 border-black rounded-xl'>
                      <p className='text-lg md:text-sm'>
                        {renderSize(cost, fields.product_type)}
                      </p>
                      <p>{cost}</p>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
      <Modal open={open} onClose={onModalClose} center>
        {/* @ts-ignore */}
        <img src={selectedMenuItem?.product_image?.[0]?.thumbnails?.large?.url} alt={selectedMenuItem?.product_image?.[0]?.filename} />
      </Modal>
    </div>
  );
};
